import { gql } from "@apollo/client"

import { useSouhlAdminQuery } from "@/provider/apollo/Apollo"

// souhl_admin supergraph への疎通確認用クエリ
// 成功 → souhl_admin、エラー → company_admin
const HelloQuery = gql`
	query HelloSouhlAdmin {
		hello
	}
`

/**
 * ログインユーザーが souhl_admin であるかを判定する hooks。
 * souhl_admin supergraph への接続が成功するかどうかで判定する。
 */
export const useIsSouhlAdmin = (): {
	isSouhlAdmin: boolean
	loading: boolean
} => {
	const { data, loading, error } = useSouhlAdminQuery(HelloQuery, {
		fetchPolicy: "cache-first",
		errorPolicy: "all",
		context: { disableErrorDialog: true },
	})

	return {
		isSouhlAdmin: !error && !!data,
		loading,
	}
}
